export default __webpack_public_path__ + "static/media/Group-1270.3585c36e.png";